import clsx from "clsx";
import React from "react";

import styles from "./SectionLabel.module.scss";

export interface SectionLabelProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title: React.ReactNode;
  resourceCount?: number;
}

const SectionLabel = ({ title, resourceCount, children, className, ...props }: SectionLabelProps) => (
  <div className={clsx(styles.sectionLabel, className)} {...props}>
    <h2 className={styles.title}>
      {title}
      {typeof resourceCount === "number" ? ` • ${resourceCount}` : null}
    </h2>
    {children}
  </div>
);

export default SectionLabel;
